import Link from 'next/link';
import React from 'react';

import Heading from '~/components/common/Heading';


const Tournament = () => {
  return (
    <>
      <Heading
        level="2"
        className="landing-page__hd-amarante type-center mb-space-l"
      >
        Tournaments every two weeks
      </Heading>
      <div className="tourney-card tourney-card--start tourney-card--red">
        <h2 className="tourney-card__title ">Valentine&rsquo;s Day Massacre</h2>
        <h3 className="tourney-card__heading">
          <strong>Grand Prize</strong> → 0.5 ETH
        </h3>
        <div className="tourney-card__button">
          <Link href="/tournaments" passHref>
            <a className="button tourney-card__button">
              View Tournaments
            </a>
          </Link>
        </div>
        <div className="tourney-card__media">
          {/* <a
                  href={PRIZES.moonbird}
                  className="link"
                  target={'_blank'}
                  rel="noreferrer"
                > */}
          <img
            src="/img/tournament/ethereum-eth.svg"
            alt="Peacefall Tournament grand prize: ethereum"
          />
          {/* </a> */}
        </div>
        <div className="tourney-card__content-bottom">
          <div>
            <h3 className="tourney-card__sub-heading">2nd Place</h3>
            <p className="tourney-card__prize-name">
                    → 0.2 ETH
            </p>
            {/* <img
                    className="prize-img"
                    src="/img/tournament/champions-2nd-prize.png"
                    alt="Peacefall Tournament of Champions 2nd Prize: Otherdeed for Otherside"
                  /> */}
          </div>

          <div>
            <h3 className="tourney-card__sub-heading">3rd-4th Place</h3>
            <p className="tourney-card__prize-name">
                    → 0.1 ETH
            </p>
            {/* <img
                    className="prize-img"
                    src="/img/tournament/champions-3rd-prize.png"
                    alt="Peacefall Tournament of Champions 3rd Prize: Forgotten Runes Wizard Cult"
                  /> */}
          </div>

          {/* <div>
                  <h3 className="tourney-card__sub-heading">4th Place</h3>
                  <p className="tourney-card__prize-name">→ Rekt Guy</p>
                  <img
                    className="prize-img"
                    src="/img/tournament/champions-4th-prize.png"
                    alt="Peacefall Tournament of Champions 4th Prize: Rekt Guy"
                  />
                </div> */}

          <div>
            <h3 className="tourney-card__sub-heading">5th-8th Place</h3>
            <p className="tourney-card__prize-name">→ 0.05 ETH</p>
            {/* <div className="prize-img-row">
                    <img
                      src="/img/tournament/champions-5th-prize.png"
                      alt="Peacefall Tournament of Champions 5th Prize: The Habibiz"
                    />
                    <img
                      src="/img/tournament/champions-6th-prize.png"
                      alt="Peacefall Tournament of Champions 6th Prize: The Habibiz"
                    />
                    <img
                      src="/img/tournament/champions-7th-prize.png"
                      alt="Peacefall Tournament of Champions 7th Prize: The Habibiz"
                    />
                    <img
                      src="/img/tournament/champions-8th-prize.png"
                      alt="Peacefall Tournament of Champions 8th Prize: The Habibiz"
                    />
                  </div> */}
          </div>
        </div>
        <div className="tourney-card__bg" aria-hidden="true"></div>

      </div>
      <div className="button-row">
        <Link href="/tournaments">
          <a className="button--pixel button--pixel--red">View Tournaments</a>
        </Link>
      </div>
    </>
  );
};

export default Tournament;
